export default function formatUnit(
  value: number,
  unit: string,
  maximumFractionDigits = 3
): string {
  return new Intl.NumberFormat(undefined, {
    style: 'unit',
    unit,
    useGrouping: false,
    maximumFractionDigits
  }).format(value);
}
